<app-header></app-header>


<div class="min-h-screen flex items-center justify-center px-4 sm:px-6 md:px-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employee-login.png)' }">

    <div class="bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow-md w-full max-w-2xl">
        <div class="flex justify-start mb-4 sm:mb-6 pb-2 border-b-[1px] ">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14" />
        </div>

        <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-4 sm:mb-6">
            {{ getVerificationTitle() }}
        </h2>
        <p class="text-center text-sm sm:text-base text-gray-500 mb-3 sm:mb-4 px-2">
            {{ getVerificationMessage() }}
        </p>

        <!-- Contact info display - only for employer login -->
        <div *ngIf="verificationType === 'login'" class="text-center text-sm sm:text-base text-gray-500 mb-3 sm:mb-4">
            <div class="font-medium mb-2">{{ maskedEmail }}</div>
            <button (click)="resendCode()" [disabled]="timer > 0 || loading"
                class="text-xs sm:text-sm text-red-500 hover:underline cursor-pointer px-3 py-2 rounded-full border border-red-300 min-h-[44px]"
                [ngClass]="{'opacity-50 cursor-default': timer > 0 || loading}">
                Resend
            </button>
        </div>

        <!-- Email info display - for signup, password reset and all employee flows -->
        <div *ngIf="verificationType === 'signup' || verificationType === 'password-reset' || verificationType.startsWith('employee-')"
            class="text-center text-sm sm:text-base text-gray-500 mb-3 sm:mb-4">
            <div class="font-medium mb-2">{{ maskedEmail }}</div>
            <button (click)="resendCode()" [disabled]="timer > 0 || loading"
                class="text-xs sm:text-sm text-red-500 hover:underline cursor-pointer px-3 py-2 rounded-full border border-red-300 min-h-[44px]"
                [ngClass]="{'opacity-50 cursor-default': timer > 0 || loading}">
                <span *ngIf="verificationType === 'signup'">Resend verification code</span>
                <span *ngIf="verificationType === 'password-reset'">Resend reset code</span>
                <span *ngIf="verificationType.startsWith('employee-')">Resend code</span>
            </button>
        </div>

        <!-- Timer display -->
        <div *ngIf="timer > 0" class="text-center mt-2 text-xs sm:text-sm text-gray-500 mb-4">
            {{ 'EMPLOYER.VERIFY.RESEND_TIMER' | translate }} {{ timer }} {{ 'EMPLOYER.VERIFY.SECONDS' | translate }}
        </div>

        <div *ngIf="verificationError"
            class="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 text-xs sm:text-sm rounded mx-auto max-w-md">
            {{ verificationError }}
        </div>

        <form *ngIf="!showSuccessScreen" [formGroup]="otpForm" autocomplete="off">
            <div formArrayName="digits" class="flex justify-center space-x-2 sm:space-x-3 md:space-x-4 my-6 sm:my-8">
                <input *ngFor="let ctrl of otpControls; let i = index" #otpInput type="text" maxlength="1"
                    class="w-10 h-12 sm:w-12 sm:h-14 text-center text-lg sm:text-xl font-semibold border rounded-md border-gray-300 focus:border-red-500 focus:outline-none"
                    [formControlName]="i" (input)="onOtpInput($event, i)" (keydown)="onOtpKeydown($event, i)"
                    (paste)="onOtpPaste($event)" autocomplete="one-time-code">
            </div>
            <div class="flex justify-center mt-6 sm:mt-8 px-2">
                <button type="button" (click)="verifyOtp()" [disabled]="!isOtpComplete() || loading"
                    class="w-full sm:max-w-xs rounded-3xl bg-white border-4 border-red-500 text-red-500 py-3 text-base sm:text-lg font-medium min-h-[48px]"
                    [ngClass]="{ 'opacity-50 cursor-default': !isOtpComplete() || loading, 'active:bg-red-500 active:text-white': isOtpComplete() && !loading }">
                    <span *ngIf="!loading">
                        <span *ngIf="verificationType === 'login'">{{ 'EMPLOYER.VERIFY.VERIFY_BUTTON' | translate
                            }}</span>
                        <span *ngIf="verificationType === 'signup'">Complete Registration</span>
                        <span *ngIf="verificationType === 'password-reset'">Verify & Reset</span>
                        <span *ngIf="verificationType.startsWith('employee-')">Verify</span>
                    </span>
                    <span *ngIf="loading" class="flex justify-center items-center">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        <span>
                            <span *ngIf="verificationType === 'login'">VERIFYING...</span>
                            <span *ngIf="verificationType === 'signup'">COMPLETING...</span>
                            <span *ngIf="verificationType === 'password-reset'">VERIFYING...</span>
                            <span *ngIf="verificationType.startsWith('employee-')">VERIFYING...</span>
                        </span>
                    </span>
                </button>
            </div>
        </form>

        <!-- Success Screen -->
        <div *ngIf="showSuccessScreen" class="my-6 sm:my-8 text-center px-2">
            <div class="flex justify-center">
                <svg class="w-12 h-12 sm:w-16 sm:h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
            </div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mt-4">{{ getSuccessTitleKey() | translate }}</h2>
            <p class="text-sm sm:text-base text-gray-600 mt-2" *ngIf="successMessage">{{ successMessage }}</p>
            <p class="text-gray-500 text-xs sm:text-sm mt-4" *ngIf="verificationType === 'signup' || verificationType === 'employee-signup'">
                {{ (userType === 'employer' ? 'EMPLOYER.VERIFY.REDIRECT_MESSAGE' : 'EMPLOYEE.VERIFY.REDIRECT_MESSAGE') | translate:{ seconds: redirectCountdown } }}
            </p>
            <!-- Show user's policies - only for login -->
            <div *ngIf="verificationType === 'login' && userPolicies.length > 0" class="mt-4 sm:mt-6">
                <h3 class="text-sm sm:text-base md:text-lg font-medium text-gray-600 mb-2">Your policies:</h3>
                <div class="bg-gray-50 rounded-lg p-3 sm:p-4 max-w-md mx-auto">
                    <div *ngFor="let policy of userPolicies"
                        class="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b border-gray-200 py-2 last:border-b-0 gap-2">
                        <span class="text-sm sm:text-base text-gray-700">{{ getPolicyDisplayNumber(policy) }}</span>
                        <span class="text-xs sm:text-sm px-2 py-1 rounded self-start sm:self-auto" [ngClass]="{
                                'bg-green-100 text-green-800': policy.status === 'INFORCE',
                                'bg-yellow-100 text-yellow-800': policy.status === 'LAPSED_WITHIN_90' || policy.status === 'TERMINATED_WITHIN_90'
                            }">
                            {{ getPolicyStatusLabel(policy.status) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>